import Flex from '@deprecated-ui/common/Flex';
import Text from '@deprecated-ui/common/Text';
import Iconmoon from '@deprecated-ui/common/Iconmoon';
import color from '@deprecated-ui/_style/color';
import {
  ButtonPolling,
  PollingBar,
  PollingBarWrapper,
  PollingValue,
} from './styled';

interface PollingOptionProps {
  fill: boolean;
  isChoice: boolean;
  textPolling: string;
  pollingValue: string;
  onClick: () => void;
  [key: string]: any;
}

function PollingOption({
  fill = false,
  isChoice = false,
  textPolling = '',
  pollingValue = '',
  onClick,
  ...otherProps
}: PollingOptionProps) {
  const parsedText = textPolling;

  return (
    <Flex {...otherProps} justify="space-between">
      <PollingBarWrapper>
        <PollingBar width={fill ? pollingValue : '100%'} fill={fill} />
        <ButtonPolling fill={fill} onClick={onClick}>
          <Flex>
            <Text
              color={fill ? color.black : color.primary}
              padding="0 12px"
              weight="normal"
              size="14.5px"
            >
              {parsedText}
            </Text>
            {isChoice && (
              <Iconmoon
                className="icon-custom_verified-circle"
                size="16px"
                color={color.primary}
              />
            )}
          </Flex>
        </ButtonPolling>
      </PollingBarWrapper>
      <PollingValue>
        {fill && (
          <Text height="40px" align="right">
            {pollingValue}
          </Text>
        )}
      </PollingValue>
    </Flex>
  );
}

export default PollingOption;
